import {NgClass} from '@angular/common';
import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import type {ChipType} from "../../models";

@Component({
  selector: 'app-chip',
  standalone: true,
  imports: [NgClass],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChipComponent {
  text = input<string>('');
  background = input<ChipType>('inactive');
}
